import React, { useState, useContext } from "react";
import "./PremiumContext.scss";
import { Tabs, Row, Col, Card, Modal, Button, Carousel, Select, Collapse, Layout } from "antd";
import Slider from "react-slick"
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
const { Content } = Layout;

const premium_context = [
    {
        'img': '/smb/premium_1.png',
        'title': 'Clear, well-lit, high-quality images',
        'desc': 'These images attract more customers to your PDP.'
    },
    {
        'img': '/smb/premium_2.png',
        'title': 'Variety of angles and image types',
        'desc': 'This helps build trust in your product and brand.'
    },
    {
        'img': '/smb/premium_3.png',
        'title': 'Accurate product details',
        'desc': 'These details create higher purchase confidence.'
    },
]

const PremiumContext = () => {

    return (
        <>
            <WebVersion />
            <MobileVersion />
        </>
    );
}


const WebVersion = () => {
    return (
        <Content className="d-none d-lg-block premium-section-big-container">
            <Row className="container-fluid justify-in-center premium-section wrap-flex">
                <Col span={24} className="justify-in-center text-center">
                    <h2 className="manrope f-30 lh-40 w-600 black-085 mb-16">Delivering premium content every time, guaranteed</h2>
                </Col>
                <Col span={17} className="justify-in-center text-center">
                    <h3 className="manrope f-16 lh-24 w-500 black-085 mb-40">Your buyers have options — we’ll ensure your products not only meet requirements of Amazon or Shopfiy, but also go above and beyond conveying quality, details, and accuracy.</h3>
                </Col>
                {premium_context.map((benefit) => (
                    <Col lg={12} xl={8} className="justify-in-center direction-flex coll pd-16">
                        <img src={benefit.img} className="mb-24" />
                        <p className="manrope f-20 w-700 lh-28 black-085 mb-8 text-center">{benefit.title}</p>
                        <p className="manrope f-16 w-400 lh-24 black-085 text-center">{benefit.desc}</p>
                    </Col>

                ))}
            </Row>
        </Content>
    );
}

const MobileVersion = () => {

    const settings = {
        autoplay: false,
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 1.07,
        slidesToScroll: 1,
        vertical: false,
        customPaging: i => (
            <div className="custom-dot">
                {/* &ndash;  This is the dash */}
            </div>
        ),
    };

    return (<Content className="d-lg-none">
        <Row className="container-fluid premium-section">
            <Col span={24} className="justify-in-start text-left pdlr-16">
                <h2 className="manrope f-24 lh-32 w-600 black-085 mb-16 text-left">Delivering premium content every time, guaranteed</h2>
            </Col>
            <Col span={24} className="justify-in-start text-left pdlr-16">
                <h3 className="manrope f-16 lh-24 w-500 black-085 mb-32 text-left">Your buyers have options—we’ll ensure your products not only meet requirements of Amazon or Shopfiy, but also go above and beyond conveying quality, details, and accuracy.</h3>
            </Col>
            <Col span={24} className="pdl-16">
                <Slider {...settings} className="premium-card">
                    {premium_context.map((benefit, index) => (
                        <div className="card-wrapper premium-card-padding" key={index}>
                            <img src={benefit.img} className="premium-img mobile mb-24" />
                            <p className="manrope f-20 w-700 lh-28 black-085 mb-8 text-left">
                                {benefit.title}
                            </p>
                            <p className="manrope f-16 w-500 lh-24 black-085 text-left">{benefit.desc}</p>
                        </div>
                    ))}
                </Slider>
            </Col>
        </Row>
    </Content>)
}

export default PremiumContext;
